import React from "react";
import PropTypes from "prop-types";
import CenteredContentWrapper from '../elements/CenteredContentWrapper';
import { YOUTUBE } from '../../constants/videoTypes';

export default class VideoSlides extends React.Component {
    state = {
        videoThumbnailsDimensions: {},
    };

    onVideoThumbnailLoad = (img, index) => {
        let { videoThumbnailsDimensions } = this.state;

        videoThumbnailsDimensions[index] = {
            height: img.offsetHeight,
            width: img.offsetWidth,
        }

        this.setState({
            videoThumbnailsDimensions,
        });
    }

    render() {
        const {
            videoThumbnailsDimensions,
        } = this.state;
        const {
            playVideo,
            videoSlides,
            title,
            subTitle,
            columns,
        } = this.props;

        return (
            <div className={'video-slides'}>
                <CenteredContentWrapper className={`wrapper columns-${columns}`}>
                    <div className={'title'}>{title}</div>
                    {subTitle ? <div className={'sub-title'}>{subTitle}</div> : false}

                    <div className={`videos-container`}>
                        {videoSlides.map((videoData, index) => {
                            const shadowSize = typeof videoThumbnailsDimensions[index] !== 'undefined' ? videoThumbnailsDimensions[index] : null;

                            return (
                                <div key={index} className={'video-block'} onClick={() => {
                                    playVideo(YOUTUBE, videoData.video)
                                }}>
                                    <div className={'thumbnail-container'}>
                                        <img onLoad={(event) => {
                                            if (!event) {
                                                return
                                            }
                                            this.onVideoThumbnailLoad(event.target, index);
                                        }} className={'thumbnail'} src={videoData.thumbnail} alt={videoData.title}/>
                                        <div style={shadowSize ? {
                                            height: shadowSize.height,
                                        } : null} className={'shadow'}></div>
                                        <img alt={'Play'} src={require('../../assets/images/landing/videoThumbnails/play.webp')} className={'play'}/>
                                    </div>
                                    <div className={'title'}>
                                        {videoData.title}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </CenteredContentWrapper>
            </div>
        );
    }
}

VideoSlides.propTypes = {
    columns: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    playVideo: PropTypes.func.isRequired,
    videoSlides: PropTypes.array.isRequired,
};
